import * as Complex from '../../../../process-data/complex';

export function computeComplexAlphaPlus(complexDenominator) {
  var result = Complex.createComplex(1, 0).divide(complexDenominator);
  return result;
}

export function computeComplexFF(complexRParallel, r1) {
  var result = complexRParallel.divide(Complex.createComplex(r1, 0));
  return result;
}
